/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Group_CreatedInputs */

const en_team_manager_group_created = /** @type {(inputs: Team_Manager_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New group created`)
};

const fr_team_manager_group_created = /** @type {(inputs: Team_Manager_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau groupe créé`)
};

const de_team_manager_group_created = /** @type {(inputs: Team_Manager_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Gruppe erstellt`)
};

const it_team_manager_group_created = /** @type {(inputs: Team_Manager_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo gruppo creato`)
};

const ru_team_manager_group_created = /** @type {(inputs: Team_Manager_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создана новая группа`)
};

const es_team_manager_group_created = /** @type {(inputs: Team_Manager_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo grupo creado`)
};

const zh_cn2_team_manager_group_created = /** @type {(inputs: Team_Manager_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建新群组`)
};

const ja_team_manager_group_created = /** @type {(inputs: Team_Manager_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいグループが作成されました`)
};

const hi_team_manager_group_created = /** @type {(inputs: Team_Manager_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया समूह बनाया गया`)
};

const pt_pt2_team_manager_group_created = /** @type {(inputs: Team_Manager_Group_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo grupo criado`)
};

/**
* | output |
* | --- |
* | "New group created" |
*
* @param {Team_Manager_Group_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_group_created = /** @type {((inputs?: Team_Manager_Group_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Group_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_group_created(inputs)
	if (locale === "de") return de_team_manager_group_created(inputs)
	if (locale === "it") return it_team_manager_group_created(inputs)
	if (locale === "ru") return ru_team_manager_group_created(inputs)
	if (locale === "es") return es_team_manager_group_created(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_group_created(inputs)
	if (locale === "ja") return ja_team_manager_group_created(inputs)
	if (locale === "hi") return hi_team_manager_group_created(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_group_created(inputs)
	return en_team_manager_group_created(inputs)
});